import { Article } from '../types';

type CollectionCategoryMap = {
  [key: string]: string[];
};
type CollectionInfo = {
  id: string;
  title: string;
  categories: string[];
};
type GroupTitlesByCollectionReturnType = {
  collections: CollectionInfo[];
  totalCategories: number;
};
type GroupTitlesByCollectionParams = {
  parentCategories: Article['parentCategories'];
};
export function groupTitlesByCollection({
  parentCategories,
}: GroupTitlesByCollectionParams): GroupTitlesByCollectionReturnType {
  const collectionCategoryMap: CollectionCategoryMap = {};
  parentCategories.forEach((category) => {
    category.parentCollections.forEach((collection) => {
      const collectionId = collection.id;
      if (!collectionCategoryMap[collectionId]) {
        collectionCategoryMap[collectionId] = [];
      }
      if (category.title) {
        collectionCategoryMap[collectionId].push(category.title);
      }
    });
  });

  const collectionInfoList: CollectionInfo[] = [];
  let totalCategories = 0;
  Object.keys(collectionCategoryMap).forEach((collectionId) => {
    const collectionTitle = parentCategories
      .flatMap((category) => category.parentCollections)
      .find((collection) => collection.id === collectionId)?.title;
    if (collectionTitle) {
      const categories = collectionCategoryMap[collectionId];
      totalCategories += categories.length;
      collectionInfoList.push({
        id: collectionId,
        title: collectionTitle,
        categories: categories,
      });
    }
  });

  return {
    collections: collectionInfoList,
    totalCategories: totalCategories,
  };
}
